module.exports = __webpack_public_path__ + "static/media/iconM3.c34cc29e.svg";